export const validateOverriddingRisk = (overriddingRiskFormData) => {
    if (!overriddingRiskFormData) {
        return false
    }
    if (overriddingRiskFormData.overriddingRiskFactorName && overriddingRiskFormData.overriddingScore) {
        return true
    } else {
        return false
    }
}

export const createOverriddingRiskRequestBody = (overriddingRiskFormData) => {
    let requestBody = {
        name: overriddingRiskFormData.values.overriddingRiskFactorName,
        score: overriddingRiskFormData.values.overriddingScore
    }
    return requestBody;
}